import { render } from "./Records.vue?vue&type=template&id=a190811e&scoped=true"
import script from "./records.js?vue&type=script&lang=js&external"
export * from "./records.js?vue&type=script&lang=js&external"

import "./Records.vue?vue&type=style&index=0&id=a190811e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a190811e"]])

export default __exports__